import { TranslationFunction } from 'i18next'
import React, { SFC } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'

import { SignalRConnection } from 'modules/signal-r'

import { i18nKeys } from '../app.i18n'
import { links } from '../app.links'
import { User } from '../auth'
import { ACTIVE_CLASS_NAME, NAVLINK_CLASS_NAME, renderNotificationBadge } from '../shared'

type Props = OwnProps & RouteComponentProps<{}>
type OwnProps = {
  user: User
  t: TranslationFunction
}

export const PersonalNav: SFC<Props> = ({ user, t }) => (
  <>
    <div className="sidebar__title">{t(i18nKeys.frontFace.activityBar.personal)}</div>
    <NavLink
      className={NAVLINK_CLASS_NAME}
      to={links.frontFace.personal.goals.home()}
      activeClassName={ACTIVE_CLASS_NAME}
      // data-test="myGoalsNavLink"
    >
      <SignalRConnection operation="GoalNotificationCount" initParams={user.personId}>
        {(data) => (
          <>
            {t(i18nKeys.frontFace.goals.label)}
            {renderNotificationBadge(data)}
          </>
        )}
      </SignalRConnection>
    </NavLink>
    {user.hasReview && (
      <NavLink
        className={NAVLINK_CLASS_NAME}
        data-test="myReviewsNavLink"
        to={links.frontFace.personal.reviews.home()}
        activeClassName={ACTIVE_CLASS_NAME}
      >
        <SignalRConnection operation="ReviewNotificationCount" initParams={user.personId}>
          {(data) => (
            <>
              {t(i18nKeys.frontFace.reviews.label)}
              {renderNotificationBadge(data)}
            </>
          )}
        </SignalRConnection>
      </NavLink>
    )}
    <NavLink
      className={NAVLINK_CLASS_NAME}
      to={links.frontFace.personal.feedback.home()}
      activeClassName={ACTIVE_CLASS_NAME}
    >
      <SignalRConnection operation="FeedbackNotificationCount" initParams={user.personId}>
        {(data) => (
          <>
            {t(i18nKeys.frontFace.feedback.label)}
            {renderNotificationBadge(data)}
          </>
        )}
      </SignalRConnection>
    </NavLink>
    <NavLink
      className={NAVLINK_CLASS_NAME}
      to={links.frontFace.personal.myDevelopment.home()}
      activeClassName={ACTIVE_CLASS_NAME}
    >
      {t(i18nKeys.frontFace.myDevelopment.label)}
    </NavLink>
    <NavLink
      className={NAVLINK_CLASS_NAME}
      to={links.frontFace.personal.blog.home()}
      activeClassName={ACTIVE_CLASS_NAME}
    >
      {t(i18nKeys.frontFace.blogs.label)}
    </NavLink>
  </>
)



// WEBPACK FOOTER //
// ./src/app/sidebar-navigation/personal.tsx